import React from 'react';
import './UserAvatar.css';

const UserAvatar = ({ 
  user, 
  size = 'medium', 
  className = '',
  showFallback = true 
}) => {
  const getInitials = (user) => {
    if (user?.name) {
      return user.name.charAt(0).toUpperCase();
    }
    if (user?.username) {
      return user.username.charAt(0).toUpperCase();
    }
    return '?';
  };

  const sizeClass = `user-avatar--${size}`;
  const classes = `user-avatar ${sizeClass} ${className}`.trim();

  if (user?.profilePicture) {
    return (
      <img 
        src={user.profilePicture} 
        alt={`${user.name || user.username}'s avatar`}
        className={classes}
      />
    );
  }

  if (showFallback) {
    return (
      <div className={`${classes} user-avatar--fallback`}>
        {getInitials(user)}
      </div>
    );
  }

  return null;
};

export default UserAvatar;